import {Box} from "@mui/material"
import {type FC, type CSSProperties} from "react"
import {TruncatedTooltip} from "../Tooltip"
import EllipsisTypography from "../customTypography/EllipsisTypography"

type Props = {
  label?: string
  style?: CSSProperties
  tags: string[] | undefined
  parentRef?: any
}

const ExpertText: FC<Props> = (props) => {
  const style: React.CSSProperties = {
    ...props.style,
  }
  const tags = props.tags || []

  return (
    <>
      <Box
        style={{
          ...style,
        }}
      >
        {tags.length === 1 ? (
          <EllipsisTypography
            text={tags[0]}
            lines={1}
            fontSize={12}
            tooltipComponent={TruncatedTooltip}
            parentRef={props.parentRef}
          />
        ) : tags.length === 2 ? (
          <EllipsisTypography
            text={`${tags[0]} | ${tags[1]}`}
            lines={1}
            fontSize={12}
            tooltipComponent={TruncatedTooltip}
            parentRef={props.parentRef}
          />
        ) : (
          <EllipsisTypography
            text={tags.slice(0, 2).join(" | ")}
            lines={1}
            fontSize={12}
            fullText={tags.join(" | ")}
            alwaysShowTooltip={true}
            tooltipComponent={TruncatedTooltip}
            parentRef={props.parentRef}
          />
        )}
      </Box>
    </>
  )
}

export default ExpertText
